// Pure view helpers for the Match Results module — ported from
// js/renderers-matchresults.js. Kept DOM-free for unit testing.

import type { ProtoFixture } from "@catbento/shared";

const MONTH_ABBR = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

/**
 * Format "YYYY-MM-DD" as "D Mon YYYY". Parsed from the string directly, NOT via
 * `new Date(str)` — that parses as UTC midnight and reading it back with local
 * getMonth()/getDate() can roll the date back a day in some timezones
 * (js/renderers-matchresults.js:8).
 */
export function formatMatchDate(dateStr: string): string {
  const [y, m, d] = String(dateStr).split("-").map(Number);
  if (!y || !m || !d) return dateStr;
  return `${d} ${MONTH_ABBR[m - 1]} ${y}`;
}

/** Distinct team names in a competition's fixtures (every home/away), sorted —
 *  the team filter's options. '' ("All Teams") is added by the caller. */
export function deriveTeamNames(fixtures: ProtoFixture[]): string[] {
  return Array.from(new Set(fixtures.flatMap((m) => [m.homeTeamName, m.awayTeamName]))).sort();
}

/** Fixtures filtered by team ('' = all) and sorted date-descending — a defensive
 *  sort even though the capture already arrives newest-first (the audited
 *  "fixed, date-descending order only"). */
export function selectFixtures(fixtures: ProtoFixture[], team: string): ProtoFixture[] {
  return fixtures
    .filter((m) => !team || m.homeTeamName === team || m.awayTeamName === team)
    .slice()
    .sort((a, b) => (a.matchDate < b.matchDate ? 1 : a.matchDate > b.matchDate ? -1 : 0));
}
